
import { useTranslation } from 'react-i18next';
import { FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

export const ResourcesSection = () => {
  const { t } = useTranslation();

  return (
    <>
      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <div className="border border-[#c9a84c]/30 bg-[#c9a84c]/10 p-6 rounded-xl mb-8">
          <h3 className="font-bold text-lg mb-3 text-[#c9a84c]">{t('plans_detail.common.useful_links')}</h3>
          <ul className="space-y-2">
            <li>
              <a
                href="https://www.chusho.meti.go.jp/kinyu/keieihosho/index.htm"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#c9a84c] hover:underline flex items-center gap-2 text-sm"
              >
                <FileText className="h-4 w-4 flex-shrink-0" />
                {t('plans_detail.keieisha_hosho.link_0_text')}
              </a>
            </li>
            <li>
              <a
                href="https://www.zenshinhoren.or.jp/guarantee-guideline/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#c9a84c] hover:underline flex items-center gap-2 text-sm"
              >
                <FileText className="h-4 w-4 flex-shrink-0" />
                {t('plans_detail.keieisha_hosho.link_1_text')}
              </a>
            </li>
          </ul>
        </div>

        <div className="border border-white/10 bg-white/5 p-6 rounded-xl">
          <h3 className="font-bold text-lg mb-3 text-white">{t('plans_detail.common.contact_title')}</h3>
          <p className="mb-4 text-white/65 leading-relaxed">
            {t('plans_detail.keieisha_hosho.contact_desc')}
          </p>
          <Button
            onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLSfGctjmssSGu73JcGfPeECrLstNGZF5w_36ePFOZLw7s-1HPg/viewform', '_blank', 'noopener,noreferrer')}
            variant="outline"
            size="lg"
            className="border-[#c9a84c] text-[#c9a84c] hover:bg-[#c9a84c]/10 bg-transparent"
          >
            {t('plans_detail.keieisha_hosho.contact_button')}
          </Button>
        </div>
      </motion.section>
    </>
  );
};
